import { window } from "global";
import { useEffect } from "react";
import { usePageTitleAndDesc } from "@ugg/shared/utils/seo-helpers";

const TermsOfService = () => {
  const getPageTitleAndDesc = usePageTitleAndDesc();

  useEffect(() => {
    window && window.scrollTo(0, 0);
  }, []);

  return (
    <div className="text-content-container content-side-padding">
      {getPageTitleAndDesc("terms_of_service")}
      <div className="text-content">
        <h1>Terms of Service</h1>
        <p>Last Updated on May 25th, 2018</p>
        <h2>Introduction</h2>
        <p>
          U.GG is, at its heart, a platform to help gamers. Although it is certainly possible to use our platform without creating
          an account, we do believe that any visitor to our site must abide by the following Terms of Service.
        </p>
        <h2>Your Acceptance</h2>
        <p>
          By using, visiting, or creating an account on the U.GG website, you signify your agreement to the following terms and
          conditions set forth herein. If you do not agree to any of these terms, please GIT GUD on your own.
        </p>
        <p>
          We may make changes to these terms and conditions at our sole discretion from time to time, and we will do our best to
          promptly notify you of any such changes. Accordingly, you must agree to any such changes regardless of whether you
          received such notification.
        </p>
        <h2>Accounts</h2>
        <p>
          If you choose to create an account on U.GG, we require you to create an accurate and complete account to access our
          services. You are solely responsible for all activity on your account. Under no circumstances should you use another
          person's account without their permission.
        </p>
        <p>
          U.GG reserves the sole right to terminate a user's account or access to specific content at any time for any conduct
          deemed to be detrimental to the U.GG community or in violation of these terms and conditions.
        </p>
        <p>
          Your privacy is very important to us. We pledge to keep any and all information associated with your account information
          safe and secure. It is our policy to never provide user information to any third party organization unless previously
          authorized by each individual user in question. Any data we collect will be used solely for the purpose of building a
          better platform.
        </p>
        <h2>Content</h2>
        <p>U.GG is not responsible for any third party content or links to any third party content.</p>
        <h2>Non-Disclosure</h2>
        <p>
          By using U.GG, you agree to not discuss or share our proprietary ideas, inventions, and features with any third party
          without our written consent.
        </p>
        <p>
          We can and will pursue our legal right to protect our inventions and intellectual property to the fullest extent of the
          law.
        </p>
        <h2>General</h2>
        <p>
          WE DO OUR BEST TO KEEP U.GG SAFE, BUT YOU USE IT AT YOUR OWN RISK. WE ARE PROVIDING U.GG AS IS WITHOUT ANY EXPRESS OR
          IMPLIED WARRANTIES INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, AND NON-INFRINGEMENT. WE DO NOT GUARANTEE THAT U.GG WILL ALWAYS BE SAFE, SECURE OR ERROR-FREE OR THAT U.GG WILL
          ALWAYS FUNCTION WITHOUT DISRUPTIONS, DELAYS OR IMPERFECTIONS. U.GG IS NOT RESPONSIBLE FOR THE ACTIONS, CONTENT,
          INFORMATION, OR DATA OF THIRD PARTIES, AND YOU RELEASE US, OUR DIRECTORS, OFFICERS, EMPLOYEES, AND AGENTS FROM ANY
          CLAIMS AND DAMAGES, KNOWN AND UNKNOWN, ARISING OUT OF OR IN ANY WAY CONNECTED WITH ANY CLAIM YOU HAVE AGAINST ANY SUCH
          THIRD PARTIES.
        </p>
        <p>
          IF YOU ARE A CALIFORNIA RESIDENT, YOU WAIVE CALIFORNIA CIVIL CODE §1542, WHICH SAYS: A GENERAL RELEASE DOES NOT EXTEND
          TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE,
          WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR. WE WILL NOT BE LIABLE
          TO YOU FOR ANY LOST PROFITS OR OTHER CONSEQUENTIAL, SPECIAL, INDIRECT, OR INCIDENTAL DAMAGES ARISING OUT OF OR IN
          CONNECTION WITH THIS STATEMENT OR U.GG, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. OUR AGGREGATE
          LIABILITY ARISING OUT OF THIS STATEMENT OR U.GG WILL NOT EXCEED THE GREATER OF ONE HUNDRED DOLLARS ($100) OR THE AMOUNT
          YOU HAVE PAID US IN THE PAST TWELVE MONTHS. APPLICABLE LAW MAY NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY OR
          INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. IN SUCH CASES, U.GG'S
          LIABILITY WILL BE LIMITED TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
